// Блок 11: Footer

export function LandingFooter(): JSX.Element {
  return (
    <footer className="border-t border-border-subtle bg-surface-subtle">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-10">
        <div className="flex flex-col md:flex-row justify-between items-start gap-10">
          {/* Logo + tagline */}
          <div className="max-w-xs">
            <a href="/" className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-comp bg-accent-brand flex items-center justify-center">
                <span className="text-xs font-bold text-white font-heading">A</span>
              </div>
              <span className="text-base font-heading font-bold text-text-primary">Anima</span>
            </a>
            <p className="mt-3 text-xs text-text-muted leading-relaxed">
              AI-ассистент, который учится отвечать как ваша команда.
            </p>
          </div>

          {/* Links */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-12 gap-y-6">
            <div>
              <h4 className="text-[11px] font-bold text-text-muted uppercase tracking-wider mb-3">Продукт</h4>
              <ul className="space-y-2">
                <li><a href="#features" className="text-sm text-text-secondary hover:text-text-primary transition-colors">Возможности</a></li>
                <li><a href="#pricing" className="text-sm text-text-secondary hover:text-text-primary transition-colors">Тарифы</a></li>
                <li><a href="#demo" className="text-sm text-text-secondary hover:text-text-primary transition-colors">Демо</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-[11px] font-bold text-text-muted uppercase tracking-wider mb-3">Компания</h4>
              <ul className="space-y-2">
                <li><a href="/login" className="text-sm text-text-secondary hover:text-text-primary transition-colors">Войти</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-[11px] font-bold text-text-muted uppercase tracking-wider mb-3">Связь</h4>
              <ul className="space-y-2">
                <li>
                  <a href="mailto:hello@shoxwave.ru" className="text-sm text-text-secondary hover:text-text-primary transition-colors">
                    hello@shoxwave.ru
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-border-subtle flex flex-col sm:flex-row justify-between items-center gap-4">
          <span className="text-xs text-text-muted">&copy; 2026 Anima</span>
        </div>
      </div>
    </footer>
  );
}
